import { PreconisationInformationDTO } from "@mra/hlp9002";

/**
 * Choix des modalités de perception de la rente
 */
export enum ChoixPerception {
    Annuel = "Annuel",
    Unique = "Unique"
}

/**
 * Permet de faciliter l'affichage et le stockage des données liées à la preconisation modifiée
 */
export type PreconisationModifiee = PreconisationInformationDTO & {
    dateEffet: string;
    choixPerception: ChoixPerception;
};
